import { ReactNode, type FC } from "react";
import { Flex, Heading, Text } from "@chakra-ui/react";
import { LaurenQuoteDesktop } from "./LaurenQuote";

interface Props {
  comment?: ReactNode;
  description?: ReactNode;
  question: ReactNode;
}

export const Prompt: FC<Props> = ({ comment, description, question }) => {
  return (
    <Flex direction="column" w="full">
      {!!comment && <LaurenQuoteDesktop>{comment}</LaurenQuoteDesktop>}
      <Heading mb={2} variant={{ base: "th-h4", md: "th-h6" }}>
        {question}
      </Heading>
      {!!description && <Text variant="th-body2">{description}</Text>}
    </Flex>
  );
};
